import React from 'react'
export default function SemCustomerComp() {
    return (
        <div>Sem consumidor para este usuario. criando um...</div>
    )
}
